export function removeProductSession() {
  localStorage.removeItem("project_role");
  localStorage.removeItem("product_id");
  localStorage.removeItem("product_logo");
  localStorage.removeItem("product_name");
  localStorage.removeItem("BSRM_USER");
  localStorage.removeItem("product-type");
  localStorage.removeItem("batch-segment");
  localStorage.removeItem("dynamic");
}

export function removeSession() {
  removeProductSession();
  localStorage.clear();
}
